// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__yyo8a","loading":"Loading_loading__+KNy6"};